interface IconDoubleAltArrowLeftProps {
  className?: string;
}

export const IconDoubleAltArrowLeft = ({
  className = "",
}: IconDoubleAltArrowLeftProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      d="M8.66699 12.6666L4.66699 7.99992L8.66699 3.33325"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M11.333 12.6666L7.33301 7.99992L11.333 3.33325"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
